import React from 'react';

import { formatDate } from '../../../helpers/date';
import { ExternalLink } from '../../Clickables/ExternalLink/ExternalLink';
import { Heading } from '../../Heading/Heading';
import { ArrowRightIcon } from '../../Icons/ArrowRightIcon';
import { Text } from '../../Text/Text';
import { useClientHasRendered } from '../../../helpers/hooks';

export const InvestorCard = ({
  url,
  documentTitle,
  displayDate,
}: {
  url: string;
  documentTitle: string;
  displayDate?: string;
}) => {
  const hasClientRendered = useClientHasRendered();
  const humanReadableDate = hasClientRendered && displayDate ? formatDate(displayDate) : undefined;
  return (
    <div className="h-[140px] w-full rounded-md bg-sea-foam p-4 hover:bg-deep-sea-15 active:bg-deep-sea-30">
      <ExternalLink
        href={url}
        target="_blank"
        className="flex size-full flex-col items-end justify-between"
      >
        <div className="w-full">
          {humanReadableDate && (
            <Text variant="sm" className="mb-1 font-semibold text-abyss">
              {humanReadableDate}
            </Text>
          )}
          <Heading variant="2xs" className="font-semibold">
            {documentTitle}
          </Heading>
        </div>
        <ArrowRightIcon />
      </ExternalLink>
    </div>
  );
};
